import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  header: {
    width: '100%',
    minHeight: '56px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fafafa',
    color: 'black',
  },
  button: {
    color: '#F97F11',
  },
  text: {
    fontSize: '0.875rem',
    fontWeight: '400',
    textTransform: 'uppercase',
  },
});

export default useStyles;
